import { createStore, createLogger } from 'vuex';
import { getDictList, getNoticeTypeList, getBranchList } from '@/request';
import user from './modules/user';
import router from './modules/router';

const debug = process.env.Node_env !== 'production';

export default createStore({
  state: {
    isOpenMenuTree: true,
    dictList: [],
    noticeTypeList: [],
    branchList: []
  },
  mutations: {
    setIsOpenMenuTree(state, isOpenMenuTree) {
      state.isOpenMenuTree = isOpenMenuTree;
    },
    setDictList(state, dictList) {
      state.dictList = dictList;
    },
    setNoticeTypeList(state, noticeTypeList) {
      state.noticeTypeList = noticeTypeList;
    },
    setBranchList(state, branchList) {
      state.branchList = branchList;
    }
  },
  actions: {
    getDictList({ commit, state }) {
      if (state.dictList.length) return;
      getDictList().then((data) => {
        if (data?.length) {
          // 去掉请选择
          data = data.filter((item) => item.id);
          commit('setDictList', data);
        }
      });
    },
    getNoticeTypeList({ commit, state }) {
      if (state.noticeTypeList.length) return;
      getNoticeTypeList({
        type: 2
      }).then((data) => {
        if (data?.length) {
          commit('setNoticeTypeList', data);
        }
      });
    },
    getBranchList({ commit, state }) {
      if (state.branchList.length) return;
      getBranchList({
        flag: 1
      }).then((data) => {
        if (data?.length) {
          commit('setBranchList', data);
        }
      });
    }
  },
  modules: {
    user,
    router
  },
  plugins: debug ? [createLogger()] : []
});
